import classNames from "classnames";
import omit from "omit.js";
import React, { cloneElement, isValidElement, useCallback, useMemo } from "react";
import { PaginationButtonAdapter } from './iPagination';

const PaginationButton: React.FC<PaginationButtonAdapter> = (props) => {
    const {
        active = false,
        disabled = false,
        className,
        style,
        iconBtn,
        showTitle,
        title,
        id,
        fieldid,
        componentClass = "a",
        eventKey,
        pageSize,
        type,
        itemRender,
        onChange,
    } = props;

    // 使用useCallback优化事件处理函数，避免在render中创建新的函数引用
    const handleClick = useCallback((event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        // 保持原有的处理逻辑
        if (active) {
            return;
        }
        if (disabled) {
            return;
        }
        if (onChange) {
            onChange(eventKey as number, Number(pageSize), event);
        }
    }, [disabled, onChange, eventKey, pageSize, active]);

    // 使用useMemo优化渲染项的计算，避免不必要的重新计算
    const itemRenderElement = useMemo(() => {
        const Component = componentClass || 'a';
        // 保持原有的omit逻辑，过滤掉不需要传递的props
        const ComponentWrap = (
            <Component
                {...omit(props, ["pageSize", "simple", "iconBtn", "showTitle", "active", "className", "style", "title", "id", "componentClass", "disabled", "eventKey", "type", "itemRender"])}
                disabled={disabled}
                onClick={handleClick}
            />
        );

        if (itemRender) {
            const render = itemRender(
                eventKey,
                type,
                ComponentWrap
            );
            if (render) {
                const renderProps: Partial<PaginationButtonAdapter> = {
                    disabled,
                    onClick: handleClick
                };
                return isValidElement(render) ? cloneElement(render, renderProps) : render;
            }
        }
        return ComponentWrap;
    }, [componentClass, disabled, eventKey, type, itemRender, handleClick, fieldid]);

    // 使用useMemo优化className的计算
    const liClassName = useMemo(() =>
        classNames(className, { active, disabled, iconBtn }),
    [className, active, disabled, iconBtn]
    );

    // 保持Dom结构不变，与原class组件相同
    return (
        <li
            title={showTitle ? title : undefined}
            className={liClassName}
            style={style}
            id={id}
            fieldid={fieldid}
        >
            {itemRenderElement}
        </li>
    );
};

// 设置默认属性
PaginationButton.defaultProps = {
    componentClass: "a",
    active: false,
    disabled: false,
};

export default PaginationButton;